<template>
    <div class="bg-primary-ellipse d-flex flex-row flex-wrap justify-content-evenly align-items-center vh-100">
        <div class="card mb-4">
            <div class="card-body bg-body-secondary bg-opacity-75 d-flex flex-column justify-content-center align-items-center gap-4 p-4">
                <transition name="fade" @before-enter="beforeEnter" @leave="leave">
                    <div v-if="errorMessage" class="alert alert-danger" role="alert">
                        {{ errorMessage }}
                    </div>
                </transition>
                <h6 class="display-6">Media Center</h6>
                <p class="text-center text-muted mb-4">
                    Welcome to the Teg Media Center, a hub for innovation and knowledge. 
                </p>
                <input
                    v-model="code"
                    placeholder="Enter your code"
                    type="password"
                    class="form-control minimal-input "
                />
                <button @click="login" class="btn btn-primary p-3 w-50">Login</button>
            </div>
         </div>
         <img src="@/assets/logo_TEGPowered_INL.png" alt="Login Image" class="login-image" />
     </div>
 </template>
 
 <script>
 export default {
     name: 'LoginPage',
     data() {
         return {
             code: '',
             errorMessage: this.$route.query.error || null,
         };
     },
     async mounted() {
        document.body.setAttribute('data-bs-theme', 'dark');
        if (this.errorMessage) {
            setTimeout(() => {
                this.errorMessage = null;
            }, 5000); 
        }
     },
     methods: {
        login() {
            this.$router.push({ path: '/', query: { code: this.code } });
        },
        beforeEnter(el) {
            el.style.opacity = 0;
        },
        leave(el, done) {
            el.offsetHeight; 
            el.style.opacity = 0; 
            setTimeout(done, 500); 
        },
     }
 };
 </script>
 
 <style lang="scss" scoped>
 
    @import "bootstrap/scss/functions"; 
    @import "bootstrap/scss/variables"; 
    @import "bootstrap/scss/mixins";

    .minimal-input {
        padding: 12px; 
        border: none;
        border-bottom: 2px solid white;
        border-radius: 0;
        background-color: $body-secondary-bg-dark;
        text-align: center;
        transition: border-bottom-color 0.9s ease; 
    }

    .minimal-input::placeholder {
        text-align: center;
        color: rgba(255, 255, 255, 0.5); 
    }

    .minimal-input:focus {
        box-shadow: none;
        outline: none !important; 
        border: none; 
        border-bottom: 4px solid #007bff; 
        background-color: $body-secondary-bg-dark;
    }
        
    .minimal-button {
        width: 100px; 
        padding: 12px; 
        border-radius: 4px;
        transition: background-color 0.3s, transform 0.3s; 
    }
    
    .minimal-button:hover {
        cursor: pointer;
        background-color: rgba(255, 255, 255, 0.425); 
        border-radius: 2px !important;
    }

    .bg-primary-ellipse{
        background: radial-gradient(
            ellipse 100% 200% at 100% 160%, 
            $body-bg-dark 90%, 
            lighten($body-bg-dark, 3.0%) 90%
        );
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

 </style>
